import Axios from "axios";

export interface Waffles {
  flags: { [key: string]: boolean };
  switches: {
    stakeholder: boolean;
    "auction-and-lot-ids": boolean;
    "manage-users-page": boolean;
    "wings-integration": boolean;
  };
}

export async function getWaffles() {
  const response = await Axios.get<Waffles>("/api/waffle/");
  return response.data;
}
